import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-copy",
  "use": "file-copy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"file-copy\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 13.5V.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.354.146l-3 3A.5.5 0 002 3.5v10a.5.5 0 00.5.5h10a.5.5 0 00.5-.5zM3 3.707L5.707 1H12v12H3V3.707zM4.5 15a.5.5 0 000 1h10a.5.5 0 00.5-.5v-13a.5.5 0 00-1 0V15H4.5zM4 5.5a.5.5 0 01.5-.5H7V2.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol